import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import TrailResults from '@alltrails/maps/components/TrailResults/TrailResults';
import useTrailNavigate from '@/hooks/useTrailNavigate';
import { useLogExploreCardViewed } from '@/utils/analyticsHelpers';
import { useAppSelector } from '@/utils/redux';

const TrailResultsMapComponents = () => {
  const logExploreCardViewed = useLogExploreCardViewed('trail');
  const onTrailNavigate = useTrailNavigate();
  const activityType = useAppSelector(state => state.exploreService.filters?.activity?.[0]);

  return (
    <TrailResults
      activityType={activityType}
      cardLocation="explore map view"
      detailedCardLocation="explore tab map view"
      mapLocation={PageStrings.EXPLORE_ALL_PAGE}
      onTrailCardViewed={logExploreCardViewed}
      onTrailNavigate={onTrailNavigate}
      preventClustering
    />
  );
};

export default TrailResultsMapComponents;
